import React from 'react';
import { Stepper, Step, StepLabel, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import { useTheme } from '../../contexts/ThemeContext';

// Custom connector styling
const CustomConnector = styled(StepConnector)(({ theme: muiTheme, ownerState, customtheme }) => ({
  // [`&.${stepConnectorClasses.alternativeLabel}`]: {
  //   top: 22,
  // },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundColor: customtheme.color.primary,
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundColor: customtheme.color.primary,
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 3,
    border: 0,
    backgroundColor: customtheme.border.medium,
    borderRadius: 1,
  },
}));

// Custom step styling
const CustomStepLabel = styled(StepLabel)(({ customtheme }) => ({
  '& .MuiStepLabel-label': {
    fontWeight: 'bold',
    fontFamily: customtheme.fontFamily,
    color: customtheme.text.tertiary,
    '&.Mui-active': {
      color: customtheme.color.primary,
    },
    '&.Mui-completed': {
      color: customtheme.color.secondary,
    },
  },
  '& .MuiStepLabel-iconContainer': {
    '& .MuiStepIcon-root': {
      fontWeight: 'bold',
      fontFamily: customtheme.fontFamily,
      color: customtheme.border.medium,
      '&.Mui-active': {
        color: customtheme.color.primary,
      },
      '&.Mui-completed': {
        color: customtheme.color.secondary,
      },
    },
  },
}));

const CustomStepper = ({ activeStep, steps }) => {
  const { theme } = useTheme();

  return (
    <Stepper
      activeStep={activeStep}
      alternativeLabel
      connector={<CustomConnector customtheme={theme} />}
    >
      {steps.map((label, index) => (
        <Step key={label}>
          <CustomStepLabel customtheme={theme}>
            {label}
          </CustomStepLabel>
        </Step>

      ))}
    </Stepper>
  );
};

export default CustomStepper;